export default __webpack_public_path__ + "static/media/twelve.3c9bb106.jpeg";